// 약관 본문 저장소. 출처는 페이지마다 다르다 (scripts/prerender-legal.mjs 의 SOURCES 표):
// 가입 시 동의받는 약관은 BE `GET /terms`, 데이터 삭제 안내처럼 동의 대상이 아닌 문서는
// docs/terms 원고. 어느 쪽이든 빌드가 확정하므로 런타임에는 출처를 몰라도 된다.
//
// 빌드 시점에 scripts/prerender-legal.mjs 가 BE 를 로케일별로 받아
// ① entry-server 의 render() 로 넘겨 SSG HTML 본문을 만들고
// ② 같은 payload 를 <script id="terms-data" type="application/json"> 로 그 HTML 에 심는다.
// 브라우저는 ②를 동기로 읽으므로 하이드레이션 시 본문 깜빡임이나 추가 요청이 없다.
// 페이지 하나가 로케일 하나라 여기 담기는 건 그 페이지 로케일의 본문뿐이다.
//
// BE 가 아직 Accept-Language 를 보지 않아 BE 문서는 /en/* 에서도 한국어다 (BE 요청 대기).

/** slug -> markdown 본문 */
export type TermsDocs = Record<string, string>;

const SCRIPT_ID = 'terms-data';

let docs: TermsDocs | null = null;

/** 서버 렌더(entry-server)에서 빌드가 받아온 본문을 주입 */
export function setTermsDocs(next: TermsDocs) {
  docs = next;
}

export function getTermsDoc(slug: string): string | null {
  if (!docs && typeof document !== 'undefined') {
    const el = document.getElementById(SCRIPT_ID);
    try {
      docs = el?.textContent ? JSON.parse(el.textContent) : {};
    } catch {
      docs = {};
    }
  }
  return docs?.[slug] ?? null;
}
